export enum HelpdeskModuleTags {
  knowledgebase = 'knowledgebase',
  documentation = 'documentation',
  templates = 'templates',
}

export const HELPDESK_TAGS = Object.values(HelpdeskModuleTags);
